export default __webpack_public_path__ + "6aabb6947216e0ff41b81621807284a7.png";